import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { createStackNavigator } from '@react-navigation/stack';
import { Text } from 'react-native';
import { AdminDashboardScreen } from '../screens/admin/AdminDashboardScreen';
import { ManageSchedulesScreen } from '../screens/admin/ManageSchedulesScreen';
import { PendingApprovalsScreen } from '../screens/admin/PendingApprovalsScreen';
import { ApprovedMeetingsScreen } from '../screens/admin/ApprovedMeetingsScreen';
import { RejectedMeetingsScreen } from '../screens/admin/RejectedMeetingsScreen';
import { UserManagementScreen } from '../screens/admin/UserManagementScreen';
import { NotificationLogsScreen } from '../screens/admin/NotificationLogsScreen';
import { MeetingDetailsScreen } from '../screens/receptionist/MeetingDetailsScreen';
import { useTheme } from '../theme/ThemeContext';

const Tab = createBottomTabNavigator();
const Stack = createStackNavigator();

const DashboardStack = () => (
  <Stack.Navigator screenOptions={{ headerShown: false }}>
    <Stack.Screen name="AdminDashboardHome" component={AdminDashboardScreen} />
    <Stack.Screen name="ApprovedMeetings" component={ApprovedMeetingsScreen} />
    <Stack.Screen name="RejectedMeetings" component={RejectedMeetingsScreen} />
    <Stack.Screen name="MeetingDetails" component={MeetingDetailsScreen} />
  </Stack.Navigator>
);

export const AdminNavigator = () => {
  const { isDark } = useTheme();

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarStyle: {
          backgroundColor: isDark ? '#0F172A' : '#FFFFFF',
          borderTopColor: isDark ? '#1E293B' : '#E2E8F0',
          height: 65,
          paddingBottom: 8,
          paddingTop: 8,
        },
        tabBarActiveTintColor: '#7C3AED',
        tabBarInactiveTintColor: '#94A3B8',
      }}
    >
      <Tab.Screen
        name="AdminDashboard"
        component={DashboardStack}
        options={{
          tabBarLabel: 'Dashboard',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>📊</Text>,
        }}
      />
      <Tab.Screen
        name="PendingApprovals"
        component={PendingApprovalsScreen}
        options={{
          tabBarLabel: 'Approvals',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>⚡</Text>,
        }}
      />
      <Tab.Screen
        name="ManageSchedules"
        component={ManageSchedulesScreen}
        options={{
          tabBarLabel: 'Schedules',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>🗓️</Text>,
        }}
      />
      {/* <Tab.Screen
        name="UserManagement"
        component={UserManagementScreen}
        options={{
          tabBarLabel: 'Users',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>👥</Text>,
        }}
      /> */}
      <Tab.Screen
        name="NotificationLogs"
        component={NotificationLogsScreen}
        options={{
          tabBarLabel: 'Audit Logs',
          tabBarIcon: ({ color }) => <Text style={{ color, fontSize: 18 }}>📲</Text>,
        }}
      />
    </Tab.Navigator>
  );
};
